import { OnInit, Component, ViewChild, Output, EventEmitter, Input, OnChanges,OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { GradeService } from "src/app/_services";
import { HowDoIVideoLinks } from "src/app/common/commonvariables";
import { LoggingPanelModel } from "../../../_models/common/LoggingPanelModel";
import { ApiRequest, IApiresponse, LogObjectActionTemplateEnum, GradeStatusEnum } from "../../../_models";
import { ClaimsService } from "../../../_services/common/claims.service";
import { LoggingPanelService } from "../../../_services/logging-panel/logging-panel.service";
import { Claims } from "../../../_models/common/claims";
import { Subscription } from "rxjs";
import { CountByStatus, GridConfig } from "src/app/_models/common/grid/grid-config";
import { ColDef } from "ag-grid-community";
import { NgOption } from "@ng-select/ng-select";
import { AppGridComponent } from "src/app/shared/grid/grid-component/grid.component";
import {IRequestGradeListForAssignEmployee, IResponseGradeListForAssignEmployee, RequestGradeListForAssignEmployee,
  AssignCategoriesToGradeListPanelInputModel,AddGradePanelInputModel,AddGradePanelOutputModel} from "src/app/_models/grade/grade";
import { first } from "rxjs/operators";
import { environment } from "src/environments/environment";

@Component({
    selector: "grade-assign-category-list-panel",
    templateUrl: "./grade-assign-category-list-panel.component.html",
    standalone: false
})
export class GradeAssignCategoryListPanelComponent implements OnInit, OnDestroy {

  @ViewChild(AppGridComponent) gridComponent: AppGridComponent;
  
  @Input() inputModel: AssignCategoriesToGradeListPanelInputModel;
  @Output() closePanelEvent = new EventEmitter<boolean>();

  claimsSubscription: Subscription;
  claims: Claims;
  videoLink = HowDoIVideoLinks.AssignCategoryToGrade;
  panelHeading:string="";

  statusValue: number;
  showClaimantPanel: boolean;
  lstClaimants: any[] = [];
  gradeList: any[] = [];
  defaultSortColumn = 'updatedOn';
  gridData: any[] = [];
  gridColumnDefs: ColDef[];
  gridConfigItems: GridConfig;
  gridFilterStatus: number = 0;
  gridFilterItems: NgOption[] = [];
  panelHeader: string;
  editedGradeId: number = 0;
  currentEditingGrade: any;
  showCategoryAssignmentPanel: boolean;
  expenseCategories: any[] = [];

  showAddGradePanel: boolean = false;
  addGradePanelInputModel: AddGradePanelInputModel;

  constructor(
    private router: Router,
    private gradeService: GradeService,
    private toastr: ToastrService,
    private claimsService: ClaimsService,
    private loggingPanelService: LoggingPanelService,
    private translate: TranslateService
  ) {
    this.claimsSubscription = this.claimsService.currentClaims.subscribe(claims => {
      this.claims = claims;
    });
  }

  ngOnInit(): void {
    this.panelHeading = this.inputModel.title;
    this.fnGetCategoriesToGrades();
    this.fnInitialiseGrid();
    this.fnGetGradeListForAssignEmployee();
  }

  ngOnDestroy() {
    this.claimsSubscription.unsubscribe();
  }

  fnClosePanel() {
    this.closePanelEvent.emit(true);
  }

  fnShowConfigureshowLoggingAlertPanel(gradeId) {
    const model = new LoggingPanelModel(
      this.claims.OrgId.toString(),
      LogObjectActionTemplateEnum.AssignGradetoCategory.toString(),
      gradeId
    );
    this.loggingPanelService.onShowLogPanel(model);
  }

  fnInitialiseGrid() {
    this.fnCreateColumnDefs();
    this.fnGetGridConfigItems();
    setTimeout(() => {
      this.gridComponent.initializeGrid();
    }, 100);
  }

  fnCreateColumnDefs() {
    this.gridColumnDefs = [
      {
        headerName: this.translate.instant('grade_name'),
        field: 'gradeName',
        resizable: true,
        sortable: true,
        suppressHeaderMenuButton: true,
        minWidth: 100,
      },
      {
        headerName: this.translate.instant('no_of_claimants'),
        field: 'assignedEmployeeCount',
        resizable: true,
        sortable: true,
        suppressHeaderMenuButton: true,
        minWidth: 200,
        width: 200,
        cellRenderer: 'formattedTextRenderer',
        headerClass: 'text-center',
        cellClass: 'text-center',
        headerComponentParams: {
          class: 'd-inline-block text-logo-blue cursor-pointer text-underline lH-12 text-right'
        },
        
      },
      {
        headerName: this.translate.instant('assign_categories'),
        field: 'assignedCategories',
        resizable: true,
        sortable: true,
        suppressHeaderMenuButton: true,
        minWidth: 100,
        headerClass: 'text-center',
        cellClass: 'text-center',
      },
      {
        headerName: this.translate.instant('label_log_history'),
        field: 'log',
        cellRenderer: 'actionRenderer',
        resizable: true,
        sortable: true,
        suppressHeaderMenuButton: true,
        minWidth: 50,
        headerClass: 'text-center',
        cellClass: 'text-center',
        headerComponentParams:
          [
            {
              buttonClass: 'fas fa-file-search',
              buttonTooltip: this.translate.instant('label_log'),
              buttonAlignmentClass: 'text-center position-relative'
            }
          ]
      },
      {
        headerName: "",
        valueGetter: 'data && data.gradeId',
        cellRenderer: 'actionRenderer',
        field: 'userActionField',
        suppressMovable: true,
        suppressHeaderMenuButton: true,
        sortable: false,
        minWidth: 100,
        headerComponentParams:
          [
            {
              buttonClass: 'fas fa-edit color-green',
              buttonTooltip: this.translate.instant('label_edit'),
              userAction: 1
            }
          ]
      }
    ];
  }

  fnGetGridConfigItems() {

    let totalGradeCount = this.gridData.length;

    let countByStatusArray = [];
    countByStatusArray.push(new CountByStatus("d-block", this.translate.instant('grade_count'), totalGradeCount, false, 0));

    this.gridConfigItems = new GridConfig(
      false,
      false,
      this.defaultSortColumn,
      "gradeId",
      this.gridFilterStatus,
      true,
      countByStatusArray,
      true,
      true,
      false,
      null,
      'desc',
      40,
      'no_data_availabe',
      null,
      null,
      false, false,
      '',
      '',
      false
    );
  }

  fnGetCategoriesToGrades() {
    this.gradeService.getCategpriesToGrade().subscribe((data) => {
      this.gridData = data.responseInfo.grades.filter(g => g.gradeStatus == GradeStatusEnum.Active);
      this.expenseCategories = data.responseInfo.categories;

      this.fnGetGridConfigItems();
      setTimeout(() => {
        this.gridComponent.refreshGridData();
      }, 100);

      this.fnHighlightRows();
    });
  }

  fnHighlightRows() {
    if (this.editedGradeId) {
      this.gridData = this.gridData.map(
        (item) => {
          if (item.gradeId == this.editedGradeId) {
            item.isRowHighlighted = true;
          }
          return item;
        });
      this.editedGradeId = 0;

      setTimeout(() => {
        this.fnUnsetGridRowHighlighted();
      }, 3000);
    }
  }

  fnUnsetGridRowHighlighted() {
    this.gridData = this.gridData.map((item) => {
      item.isRowHighlighted = false;
      return item;
    });

    this.gridComponent.unsetRowHighlighted(this.gridData);
  }

  fnOnGridCellClick(params) {
    switch (params.column.colId) {
      case 'selected':
        if (params.data.selected) {
          this.currentEditingGrade = params.data;
          this.showCategoryAssignmentPanel = true;
        }
        else {
          this.currentEditingGrade = null;
        }
        break;
      case 'assignedEmployeeCount':
        this.lstClaimants = [];
        var selectedItem = this.gradeList.filter(d => d.gradeId == params.data.gradeId);
        this.showClaimantPanel = true;
        this.lstClaimants = selectedItem;
        this.panelHeader = this.translate.instant('list_of_claimants_assigned_to').replace('{0}', params.data.gradeName + ': ' + params.data.assignedEmployeeCount);
        break;
        break;
      case 'log':
        this.fnShowConfigureshowLoggingAlertPanel(params.data.gradeId.toString());
        break;
      case 'userActionField':
        this.currentEditingGrade = params.data;
        this.gridComponent.checkItems([params.data.gradeId]);
        this.showCategoryAssignmentPanel = true;
        break;
    }
  }

  fnGetGradeListForAssignEmployee() {
    let gradeRequest = new ApiRequest<IRequestGradeListForAssignEmployee>("SoloGetGradeListForAssignEmployee",environment.applicationVersion, environment.requestId);
    let gradeRequestInfo = new RequestGradeListForAssignEmployee(
      this.claims.OrgId,
      this.statusValue
    );

    gradeRequest.requestInfo = gradeRequestInfo;

    this.gradeService.GetGradeListForAssignEmployee(gradeRequest)
      .subscribe(
        (response: any) => {
          if (response.responseInfo != null) {
            this.gradeList = response.responseInfo.lstEmployee;
          }
        }
      );
  }

  fnPanelReceiver() {
    this.showClaimantPanel = false;
  }

  fnCloseAssignCategoryPanel(isSaved) {
    if (isSaved) {
      this.editedGradeId = this.currentEditingGrade.gradeId;
      this.currentEditingGrade = null;
      this.fnGetCategoriesToGrades();
    }
    this.gridComponent.uncheckAll();
    this.showCategoryAssignmentPanel = false;
  }

fnShowAddGradePanel(gradeId: number, isEdit: boolean = false,isCopy:boolean= false) {
    this.addGradePanelInputModel = new AddGradePanelInputModel(gradeId, isEdit,isCopy);
    this.showAddGradePanel = true;
  }

fnCloseAddGradePanel(isClose: boolean) {
    if (isClose) {
        this.addGradePanelInputModel = null;
        this.gridComponent.uncheckAll();
        this.showAddGradePanel = false;
    }
}

fnSubmitAddGradePanel(response: AddGradePanelOutputModel) {
    if (response) {
        this.addGradePanelInputModel = null;  
        this.showAddGradePanel = false;
        this.fnGetCategoriesToGrades();
    }
}

}
